import {
  ProjectFulfillmentMethod,
  ProjectShippingType
} from '@customink/project-service-types';

export const serializeProjectConfiguration = (project, fulfillmentPlatform) => {
  let fulfillmentMethod;
  let shippingType;

  if (fulfillmentPlatform) {
    if (fulfillmentPlatform === 'GOFIndividual') {
      fulfillmentMethod = ProjectFulfillmentMethod.GROUPS;
      shippingType = ProjectShippingType.INDIVIDUAL;
    } else if (fulfillmentPlatform === 'GOFBulk') {
      fulfillmentMethod = ProjectFulfillmentMethod.GROUPS;
      shippingType = ProjectShippingType.BULK;
    } else if (fulfillmentPlatform === 'BULK') {
      fulfillmentMethod = ProjectFulfillmentMethod.BULK;
      shippingType = ProjectShippingType.BULK;
    } else if (fulfillmentPlatform === 'BSS') {
      fulfillmentMethod = ProjectFulfillmentMethod.BSS;
      shippingType = ProjectShippingType.INDIVIDUAL;
    }
  }

  return {
    id: project.id,
    configuration: {
      fulfillmentMethod: fulfillmentMethod || project.fulfillmentMethod,
      paymentSource: project.payment,
      shippingType: shippingType || project.shippingType,
      shippingInfoSource: project.shipping,
      sizeQuantitySource: project.sizes,
      estimatedTotalQuantity: project.estimatedQty
    }
  };
};
